import { translate as t } from "./locale";
interface ProjectDeleteDialogProps {
    count: number;
    onCancel: () => void;
    onConfirm: () => void | Promise<void>;
    working: boolean;
}

export const ProjectDeleteDialog = ({
    count,
    onCancel,
    onConfirm,
    working,
}: ProjectDeleteDialogProps) => (
    <div className="modal-overlay">
        <section
            aria-labelledby="project-delete-title"
            aria-modal="true"
            className="import-dialog"
            role="dialog"
        >
            <div className="import-dialog-content">
                <h2 id="project-delete-title">
                    {count === 1 ? t("Usunąć projekt?") : t("Usunąć zaznaczone projekty ({value0})?", { value0: count })}
                </h2>
                <p>{t("Projekt zostanie przeniesiony do kosza administratora.")}</p>
                <div className="dialog-actions">
                    <button
                        className="danger-button"
                        disabled={working}
                        onClick={() => void onConfirm()}
                        type="button"
                    >
                        {working ? t("Usuwanie…") : t("Usuń")}
                    </button>
                    <button className="secondary-button" disabled={working} onClick={onCancel} type="button">
                        {t("Anuluj")}
                    </button>
                </div>
            </div>
        </section>
    </div>
);
